import type { SystemStyleObject } from "@ui/types";
import { focusOutline } from "@ui/css/02.focus/focus.styles";

export const dropdownItemStyle: SystemStyleObject = {
    mx: 2,
    my: 1,
    display: "flex",
    width: "90%",
    _focusVisible: {
        ...focusOutline,
        borderRadius: "4px",
    },
    _focus: {
        background: "transparent",
    },
    _hover: { backgroundColor: "transparent" },
    p: {
        fontWeight: "bold",
        _hover: {
            textDecor: "none",
        },
    },
};
